import { queryAvailability } from './api/query-availability';
import { getLocalDateTimeEndOfDay, getLocalDateTimeStartOfDay } from './date-utils';
export const getAvailabilitySlots = _ref => {
  let {
    httpClient: _httpClient,
    errorHandler
  } = _ref;
  return async _ref2 => {
    var _await$queryAvailabil;
    let {
      serviceId,
      selectedDate,
      timeZone
    } = _ref2;
    const fromLocalDate = getLocalDateTimeStartOfDay(selectedDate);
    const toLocalDate = getLocalDateTimeEndOfDay(selectedDate);
    return (_await$queryAvailabil = await queryAvailability({
      httpClient: _httpClient,
      errorHandler,
      request: {
        query: {
          filter: {
            serviceId: [serviceId],
            startDate: fromLocalDate,
            endDate: toLocalDate,
            bookable: true
          }
        },
        timezone: timeZone,
        allowProxyToAvailability: true
      }
    })) == null ? void 0 : _await$queryAvailabil.availabilityEntries;
  };
};
//# sourceMappingURL=get-availability-slots.js.map